
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Select from "react-select";
import { Link, useNavigate, useParams } from "react-router-dom";

import DataTable from "react-data-table-component";

/* MATERIAL TAILWIND COMPONENTS */
import { Button } from "@material-tailwind/react";

/* ICONS */
import { TbFileInvoice } from "react-icons/tb";

/* SAMPLE DATA */
import inventory from "../../../../data/inventory";
import { BiCheck } from "react-icons/bi";
import TextArea from "../../../../components/textarea";
import InputField from "../../../../components/input";

import {
  getRegistrationDetails,
  patchRegistrationDetailsStatusById,
} from "../../../../service/api/auth.api";
import { toast } from "react-toast";
import { IMAGE_URL } from "../../../../config";
import moment from "moment/moment";
import { useSelector } from "react-redux";
import { handleAddToken } from "../../../../service/request";

const VendorDetails = () => {
  // GLOBAL VARIABLES
  const { id } = useParams();
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state?.user);
  // STATE VARIABLES
  const [loading, setLoading] = useState(false);
  const [registrationDetails, setRegistrationDetails] = useState(null);

  /* HANDLE DELETE DATA */
  const handleGetRegistrationDetailsDetails = async () => {
    setLoading(true); 
    try {
      await handleAddToken(userDetails?.token);
      const res = await getRegistrationDetails(id);
      toast.success(res?.message);
      setRegistrationDetails(res?.data);
    } catch (error) {
      console.log("%c Line:54 🥒 error", "color:#ea7e5c", error);
      toast.error(error?.response?.data?.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    handleGetRegistrationDetailsDetails();
  }, [id]);

  return (
    <section className="px-0 py-2 xl:p-10 lg:p-10 min-h-screen xl:min-h-full lg:min-h-full">
      {/* PAGE TITLE */}
      <Helmet>
        <title>Vendor Details |CIDA Perfumes</title>
      </Helmet>

      <div className="container-full-width">
        <div className="block xl:flex lg:flex items-center justify-between">
          {/* HEADING */}
          <div>
            <h1 className="text-3xl font-proxima-bold text-black tracking-tight">
              Edit Vendor Details
            </h1>
            <h2 className="text-lg font-proxima-regular text-greyText tracking-tight">
              Registration details have been forwarded to{" "}
              <span className="font-proxima-bold">
                {registrationDetails?.email}
              </span>
            </h2>
          </div>

          {/* VIEW INVOICE */}
          <div className="flex items-center gap-2 mt-2 xl:mt-0 lg:mt-0">
            <Button
              onClick={() => {
                navigate("/vendors");
              }}
              className="w-full xl:w-auto lg:w-auto whitespace-nowrap xl:whitespace-normal lg:whitespace-normal shadow-none hover:shadow-none bg-white hover:bg-black hover:bg-opacity-5 px-5 py-3 rounded-md border border-authBorder text-sm font-proxima-semibold text-black normal-case transition-all duration-300 ease-in-out"
            >
              Back to Vendors
            </Button>
            <Button className="w-full  xl:w-auto lg:w-auto whitespace-nowrap xl:whitespace-normal lg:whitespace-normal justify-center shadow-none hover:shadow-none bg-logoYellow hover:bg-opacity-80 px-5 py-3 rounded-md border border-logoYellow text-sm font-proxima-semibold text-white normal-case transition-all duration-300 ease-in-out flex hidden">
              Save Details
            </Button>
          </div>
        </div>

        {/* CUSTOMERS LIST */}
        <div className="mt-5 xl:mt-5 lg:mt-5">
          <div className=" bg-white border border-authBorder rounded-md overflow-y-auto overflow-x-hidden hide-scrollbar">
            <div className="p-5">
              <div className=" border-b border-authBorder flex justify-between">
                <div>
                  <h5 className="text-lg font-proxima-bold text-black">
                    Web Account InformationDetails
                  </h5>
                  <p className="text-sm font-proxima-regular text-greyText">
                    Fill in these product specific details
                  </p>
                </div>

                <div className="form-group pb-3">
                  <div className="">
                    <Select
                      options={[]}
                      placeholder="Select Status"
                      name="tag"
                      id="tag"
                      isMulti
                      classNamePrefix="dropdown"
                      // onChange={(event) =>
                      //   addRegistrationDetailsFormik.setFieldValue("tag", event?.value)
                      // }
                      // value={tagList?.find(
                      //   (el) => el?.value === addRegistrationDetailsFormik.values.tag
                      // )}
                    />
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-4 gap-5 mt-3">
                {/* EMAIL ADDRESS */}
                <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                  <div className="form-group">
                    <label className="text-sm font-proxima-semibold text-black">
                      Email Address <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <InputField
                        type="email"
                        name="name"
                        id="name"
                        // onChange={addRegistrationDetailsFormik.handleChange}
                        value={registrationDetails?.email}
                        disabled={true}
                        // error={
                        //   addRegistrationDetailsFormik.errors.name &&
                        //   addRegistrationDetailsFormik.touched.name
                        //     ? true
                        //     : false
                        // }
                        placeholder="Write the email address"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-5 xl:mt-5 lg:mt-5">
          <div className=" bg-white border border-authBorder rounded-md overflow-y-auto overflow-x-hidden hide-scrollbar">
            <div className="p-5">
              <div className=" border-b border-authBorder flex justify-between pb-3">
                <div>
                  <h5 className="text-lg font-proxima-bold text-black">
                    Web Account InformationDetails
                  </h5>
                  <p className="text-sm font-proxima-regular text-greyText">
                    Fill in these product specific details
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-4 gap-5 mt-3">
                {/* FIRST NAME */}
                <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                  <div className="form-group">
                    <label className="text-sm font-proxima-semibold text-black">
                      First Name <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <InputField
                        type="text"
                        name="sku"
                        id="sku"
                        // onChange={addRegistrationDetailsFormik.handleChange}
                        // value={addRegistrationDetailsFormik.values.sku}
                        // error={
                        //   addRegistrationDetailsFormik.errors.sku &&
                        //   addRegistrationDetailsFormik.touched.sku
                        //     ? true
                        //     : false
                        // }
                        value={registrationDetails?.firstName}
                        disabled={true}
                        placeholder="Write the first name"
                      />
                    </div>
                  </div>
                </div>

                {/* Last NAME */}
                <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                  <div className="form-group">
                    <label className="text-sm font-proxima-semibold text-black">
                      Last Name <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <InputField
                        type="text"
                        name="sku"
                        id="sku"
                        // onChange={addRegistrationDetailsFormik.handleChange}
                        // value={addRegistrationDetailsFormik.values.sku}
                        // error={
                        //   addRegistrationDetailsFormik.errors.sku &&
                        //   addRegistrationDetailsFormik.touched.sku
                        //     ? true
                        //     : false
                        // }
                        value={registrationDetails?.lastName}
                        disabled={true}
                        placeholder="Write the last name"
                      />
                    </div>
                  </div>
                </div>

                {/* EMAIL */}
                <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                  <div className="form-group">
                    <label className="text-sm font-proxima-semibold text-black">
                      Email Address <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <InputField
                        type="email"
                        name="name"
                        id="name"
                        // onChange={addRegistrationDetailsFormik.handleChange}
                        // value={addRegistrationDetailsFormik.values.name}
                        // error={
                        //   addRegistrationDetailsFormik.errors.name &&
                        //   addRegistrationDetailsFormik.touched.name
                        //     ? true
                        //     : false
                        // }
                        value={registrationDetails?.contactInformation?.email}
                        disabled={true}
                        placeholder="Write the email address"
                      />
                    </div>
                  </div>
                </div>

                {/* PHONE NUMBER */}
                <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                  <div className="form-group">
                    <label className="text-sm font-proxima-semibold text-black">
                      Phone Number <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <InputField
                        type="text"
                        name="sku"
                        id="sku"
                        // onChange={addRegistrationDetailsFormik.handleChange}
                        // value={addRegistrationDetailsFormik.values.sku}
                        // error={
                        //   addRegistrationDetailsFormik.errors.sku &&
                        //   addRegistrationDetailsFormik.touched.sku
                        //     ? true
                        //     : false
                        // }
                        value={
                          registrationDetails?.contactInformation?.phoneNumber
                        }
                        disabled={true}
                        placeholder="Write the Phone Number"
                      />
                    </div>
                  </div>
                </div>

                {/* ADDRESS LINE 1 */}
                <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                  <div className="form-group">
                    <label className="text-sm font-proxima-semibold text-black">
                      Address Line 1 <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <InputField
                        type="text"
                        name="sku"
                        id="sku"
                        // onChange={addRegistrationDetailsFormik.handleChange}
                        // value={addRegistrationDetailsFormik.values.sku}
                        // error={
                        //   addRegistrationDetailsFormik.errors.sku &&
                        //   addRegistrationDetailsFormik.touched.sku
                        //     ? true
                        //     : false
                        // }
                        value={registrationDetails?.address?.[0]?.addressLine1}
                        disabled={true}
                        placeholder="Write the Address "
                      />
                    </div>
                  </div>
                </div>

                {/* ADDRESS LINE 2 */}
                <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                  <div className="form-group">
                    <label className="text-sm font-proxima-semibold text-black">
                      Address Line 2
                    </label>
                    <div className="mt-1">
                      <InputField
                        type="text"
                        name="sku"
                        id="sku"
                        // onChange={addRegistrationDetailsFormik.handleChange}
                        // value={addRegistrationDetailsFormik.values.sku}
                        // error={
                        //   addRegistrationDetailsFormik.errors.sku &&
                        //   addRegistrationDetailsFormik.touched.sku
                        //     ? true
                        //     : false
                        // }
                        value={
                          registrationDetails?.address?.[0]?.addressLine2
                            ? registrationDetails?.address?.[0]?.addressLine2
                            : ""
                        }
                        disabled={true}
                        placeholder="Write the address line 2"
                      />
                    </div>
                  </div>
                </div>

                {/* CITY */}
                <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                  <div className="form-group">
                    <label className="text-sm font-proxima-semibold text-black">
                      City <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <InputField
                        type="text"
                        name="sku"
                        id="sku"
                        // onChange={addRegistrationDetailsFormik.handleChange}
                        // value={addRegistrationDetailsFormik.values.sku}
                        // error={
                        //   addRegistrationDetailsFormik.errors.sku &&
                        //   addRegistrationDetailsFormik.touched.sku
                        //     ? true
                        //     : false
                        // }
                        value={registrationDetails?.address?.[0]?.city}
                        disabled={true}
                        placeholder="Write the City "
                      />
                    </div>
                  </div>
                </div>

                {/* STATE */}
                <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                  <div className="form-group">
                    <label className="text-sm font-proxima-semibold text-black">
                      State <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <InputField
                        type="text"
                        name="sku"
                        id="sku"
                        // onChange={addRegistrationDetailsFormik.handleChange}
                        // value={addRegistrationDetailsFormik.values.sku}
                        // error={
                        //   addRegistrationDetailsFormik.errors.sku &&
                        //   addRegistrationDetailsFormik.touched.sku
                        //     ? true
                        //     : false
                        // }
                        value={registrationDetails?.address?.[0]?.state}
                        disabled={true}
                        placeholder="Write the state"
                      />
                    </div>
                  </div>
                </div>

                {/* PIN CODE */}
                <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                  <div className="form-group">
                    <label className="text-sm font-proxima-semibold text-black">
                      Pin Code <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <InputField
                        type="text"
                        name="sku"
                        id="sku"
                        // onChange={addRegistrationDetailsFormik.handleChange}
                        // value={addRegistrationDetailsFormik.values.sku}
                        // error={
                        //   addRegistrationDetailsFormik.errors.sku &&
                        //   addRegistrationDetailsFormik.touched.sku
                        //     ? true
                        //     : false
                        // }
                        value={registrationDetails?.address?.[0]?.zipCode}
                        disabled={true}
                        placeholder="Write the Pin Code"
                      />
                    </div>
                  </div>
                </div>

                {/* COUNTRY */}
                <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                  <div className="form-group">
                    <label className="text-sm font-proxima-semibold text-black">
                      Country <span className="text-red-500">*</span>
                    </label>
                    <div className="mt-1">
                      <InputField
                        type="text"
                        name="sku"
                        id="sku"
                        // onChange={addRegistrationDetailsFormik.handleChange}
                        // value={addRegistrationDetailsFormik.values.sku}
                        // error={
                        //   addRegistrationDetailsFormik.errors.sku &&
                        //   addRegistrationDetailsFormik.touched.sku
                        //     ? true
                        //     : false
                        // }
                        value={registrationDetails?.address?.[0]?.country}
                        disabled={true}
                        placeholder="Write the Country"
                      />
                    </div>
                  </div>
                </div>

                {/* GST Number */}
                <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                  <div className="form-group">
                    <label className="text-sm font-proxima-semibold text-black">
                      GST Identification Number{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <div
                      onClick={() => {
                        navigate(
                          IMAGE_URL +
                            registrationDetails?.attachedDocument?.find(
                              (el) =>
                                el?.documentName === "GST Identification Number"
                            )?.documentURL
                        );
                      }}
                      className="float-right cursor-pointer text-sm font-proxima-semibold text-black"
                    >
                      <p>View Document</p>
                    </div>
                    <div className="mt-1">
                      <InputField
                        type="text"
                        name="sku"
                        id="sku"
                        // onChange={addRegistrationDetailsFormik.handleChange}
                        // value={addRegistrationDetailsFormik.values.sku}
                        // error={
                        //   addRegistrationDetailsFormik.errors.sku &&
                        //   addRegistrationDetailsFormik.touched.sku
                        //     ? true
                        //     : false
                        // }
                        value={registrationDetails?.gstNumber}
                        disabled={true}
                        placeholder="Write the GST Number"
                      />
                    </div>
                  </div>
                </div>

                {/* PAN Card */}
                <div className="col-span-2 xl:col-span-1 lg:col-span-1">
                  <div className="form-group">
                    <label className="text-sm font-proxima-semibold text-black">
                      PAN Card Number <span className="text-red-500">*</span>
                    </label>
                    <div
                      onClick={() => {
                        navigate(
                          IMAGE_URL +
                            registrationDetails?.attachedDocument?.find(
                              (el) => el?.documentName === "PAN Card Number"
                            )?.documentURL
                        );
                      }}
                      className="float-right cursor-pointer text-sm font-proxima-semibold text-black"
                    >
                      <p>View Document</p>
                    </div>
                    <div className="mt-1">
                      <InputField
                        type="text"
                        name="sku"
                        id="sku"
                        // onChange={addRegistrationDetailsFormik.handleChange}
                        // value={addRegistrationDetailsFormik.values.sku}
                        // error={
                        //   addRegistrationDetailsFormik.errors.sku &&
                        //   addRegistrationDetailsFormik.touched.sku
                        //     ? true
                        //     : false
                        // }
                        value={registrationDetails?.panCardNumber}
                        disabled={true}
                        placeholder="Write the PAN Card Number "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default VendorDetails;
